export default __webpack_public_path__ + "static/media/userIcon.5a4519f0.jpg";